import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiPipesModule } from '@netfoundry-ui/ui/pipes';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UiLoaderModule } from '@netfoundry-ui/ui/loader';
import { UiRxTxTimelineChartModule } from '@netfoundry-ui/ui/rx-tx-timeline-chart';
import { SharedApiv2Module } from '@netfoundry-ui/shared/apiv2';
import { SharedModelModule } from '@netfoundry-ui/shared/model';
import { OpenZitiConsoleLibModule } from 'ziti-console-lib';
import { FlowDiagramComponent } from '@netfoundry-ui/ui/flow-diagram';
import { IpsecTunnelerExtensionComponent } from './ipsec-tunneler-extension/ipsec-tunneler-extension.component';
import { RefreshControlsComponent } from '@netfoundry-ui/ui/refresh-controls';

@NgModule({
    imports: [
        RefreshControlsComponent,
        FlowDiagramComponent,
        ClickOutsideModule,
        FormsModule,
        CommonModule,
        RouterModule,
        UiPipesModule,
        MatTooltipModule,
        UiLoaderModule,
        UiRxTxTimelineChartModule,
        SharedApiv2Module,
        SharedModelModule,
        OpenZitiConsoleLibModule,
    ],
    declarations: [IpsecTunnelerExtensionComponent],
    exports: [IpsecTunnelerExtensionComponent],
})
export class PageIpsecTunnelerExtensionModule {}
